var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreakFreeze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 248,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 134.14,
    y1: 100.85,
    x2: 308.98,
    y2: 554.13,
    gradientTransform: "translate(-82.49 -100.04) rotate(3.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29abe2",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0071bc"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "57.87 224.59 156.72 206.46 250.98 219.2 135.57 240.48 57.87 224.59",
    style: {
      fill: "#29abe2",
      opacity: 0.57
    }
  }), _text || (_text = /*#__PURE__*/React.createElement("text", null)), /*#__PURE__*/React.createElement("path", {
    d: "m191.19,124.87c-1.18-2.29-2.33-5.04-3.92-7.81l-24.25,24.14s-32.77-47.92-35.21-51.19c-20.07,21.3-30.23,33.95-31.24,48.98-1.74,26.02,14.01,44.21,36.33,49.84,3.47.88,7.09,1.45,10.84,1.7,11.05.74,21.87-1.64,30.68-7.28,19.89-11.99,26.02-37.33,16.78-58.38Zm0,0c-1.18-2.29-2.33-5.04-3.92-7.81l-24.25,24.14s-32.77-47.92-35.21-51.19c-20.07,21.3-30.23,33.95-31.24,48.98-1.74,26.02,14.01,44.21,36.33,49.84,3.47.88,7.09,1.45,10.84,1.7,11.05.74,21.87-1.64,30.68-7.28,19.89-11.99,26.02-37.33,16.78-58.38Zm27.9-63.98l-21.35,6.28c17,25.75,27.73,56.26,26.86,69.25-2.98,44.65-40.29,78.12-83.16,75.26-2.5-.17-4.98-.45-7.4-.86-39.51-6.46-67.84-42.72-65.03-84.79.67-10.07,6.66-24.7,17.09-41.04l-23.89-1.59c-8.51,15.21-13.64,29.46-14.43,41.22-3.64,54.47,35,101.72,87.37,107.83,1.61.18,3.23.34,4.86.45,54.37,3.63,102.05-38.92,105.8-95.06,1.15-17.2-9.19-48.79-26.74-76.94Zm-32.79,10.81c.54-.55,1.08-1.1,1.62-1.65l-28.77,8.46,8.51,13.26,18.65-20.07Zm-53.4,117.12c3.47.88,7.09,1.45,10.84,1.7,11.05.74,21.87-1.64,30.68-7.28,19.89-11.99,26.02-37.33,16.78-58.38-1.18-2.29-2.33-5.04-3.92-7.81l-24.25,24.14s-32.77-47.92-35.21-51.19c-20.07,21.3-30.23,33.95-31.24,48.98-1.74,26.02,14.01,44.21,36.33,49.84Z",
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.57,240.48l-77.7-15.89S13.73,88.81,7.78,79.77l119.9,8,.12,2.24,5.1,98.82,1.14,22,1.12,21.62.41,8.02Z",
    style: {
      fill: "url(#linear-gradient)",
      opacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.98,219.2l-115.41,21.27-.41-8.02-1.12-21.62-1.14-22-5.1-98.82-.12-2.24,31.45-9.25,28.77-8.46,9.83-2.89,21.35-6.28,55.91-16.44s-23.91,162.09-24.02,174.75Z",
    style: {
      fill: "#29abe2",
      opacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275 44.41 127.68 87.72 7.78 79.72 156.54 47.84 170.07 47.45 176.8 45.43 196.34 46.59 203.27 48.21 222.91 45.91 233.74 46.2 256.18 45.55 254.77 44.99 262.03 44.78 275 44.41",
    style: {
      fill: "#1d8cb2",
      opacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.08,60.9l-21.35,6.28c-.93-1.42-1.89-2.83-2.86-4.21-2.32,2.37-4.63,4.73-6.96,7.1l-28.77,8.46-6.38-9.94c-7.24-11.14-15.35-22.78-24.4-33.59-17.75,16.56-32.11,34.1-42.26,50.01l-23.89-1.59c14.52-25.95,38.85-54.67,68.15-78.47,15.73,17.03,29.64,34.83,40.46,52.42,7.69-8.81,16.68-17.08,26.53-24.87,8.06,8.45,15.37,18.21,21.73,28.41Z",
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.29,70.64l-.85.15c-9.44,1.46-18.76,3.57-28.07,5.69-4.86,1.11-9.72,2.22-14.59,3.33,3.06-3.85,6.86-7,10.77-9.99.84-.65,1.69-1.28,2.53-1.92.68-.51,1.41-1.04,2.25-1.11,1-.08,1.9.51,2.85.82,2.3.76,4.86-.11,6.83-1.5,1.98-1.39,3.54-3.28,5.31-4.93.64-.61,1.35-1.19,2.14-1.58.41-.21.84-.36,1.3-.43,1.77-.29,3.47.65,5.02,1.54,3.78,2.2,17.03,3.32,20.81,5.52,1.04.61-9.72,3.66-16.29,4.41Z",
    style: {
      fill: "#d6faff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "201.93 227.4 220.02 187.42 214.71 151.54 224.82 131.55 228.44 95.86 225.8 135.46 215.81 152.22 222.19 189.53 201.87 228.3",
    style: {
      fill: "#29abe2",
      opacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.53,35.82c.21,1.19-.49,2.37-1.4,3.16s-2.03,1.29-3.06,1.92c-3.95,2.44-6.29,6.7-9,10.46-2.71,3.76-6.48,7.41-11.12,7.48-.91.01-1.88-.11-2.68.34-.36.2-.66.5-1,.73-1.34.93-3.75.17-3.66-1.46.06-1.09,1.1-1.81,2-2.42,4.08-2.76,7.4-6.64,9.48-11.1.23-.5.46-1.02.88-1.38.77-.65,2.01-.6,2.68-1.36.28-.31.41-.72.57-1.11.88-2.11,2.76-3.79,4.96-4.41.38-.11.77-.19,1.09-.41.76-.53.86-1.65,1.54-2.3.85-.81,2.27-.57,3.3-1.14.47-.26.83-.67,1.29-.95.9-.54,2.14-.45,2.94.23s1.12,1.87.75,2.85",
    style: {
      fill: "#d6faff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.44,59.59l-.15,2.23s-1.09,3.37-3.03,6.69c-1.94,3.32-6.98,1.26-7.57,1.24-.59-.01-2.95,1.5-6.29.99-3.33-.51-4.87-.94-4.87-.94.84-.65,1.69-1.28,2.53-1.92.68-.51,1.41-1.04,2.25-1.11,1-.08,1.9.51,2.85.82,2.3.76,4.86-.11,6.83-1.5,1.98-1.39,3.54-3.28,5.31-4.93.64-.61,1.35-1.19,2.14-1.58Z",
    style: {
      fill: "#add8db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.77,79.81s14.1-.26,19.42-2.49c5.32-2.23,10.52-2.74,11.38-2.69.86.06,7.83-1.2,7.83-1.2,0,0,6.08-3.08,6.58-3.03s7.43-.35,7.43-.35l7.15-3.83s-42.78,8.35-45.41,9.03c-2.63.69-5.39,1.65-5.39,1.65,0,0-3.41,1.21-4.27,1.15s-4.73,1.74-4.73,1.74Z",
    style: {
      fill: "#d6faff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.48 153.58 42.3 130.58 51.04 129.02 62.33 94.08 50.35 128.08 41.09 129.73 43.48 153.58",
    style: {
      fill: "#29abe2",
      opacity: 0.57
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.12,87.95c-1.93.74-4.07-.31-6.12-.18-4,.26-6.46,4.68-10.24,5.99-.89.3-1.94.49-2.47,1.27-.31.45-.38,1.03-.49,1.56-.29,1.39-.92,2.7-1.82,3.78-.3.35-.64.7-1.09.83-1.48.44-2.42-1.51-2.83-2.99-.81-2.89-2.14-5.63-3.92-8.05-.99-1.37-2.31-2.72-3.99-2.85-.75-.06-1.52.14-2.26,0-1.3-.24-2.18-1.4-3.16-2.3-1.49-1.38-3.45-2.26-5.48-2.45,2.55-1.46,5.1-2.92,7.65-4.37.83-.47,1.68-.96,2.6-1.19,1.37-.36,2.84-.16,4.2-.54,2.02-.56,3.58-2.33,5.66-2.64.95-.13,1.93.05,2.85-.17,1.44-.34,2.47-1.56,3.66-2.44,1.19-.88,3.01-1.38,4.04-.32.31.32.49.73.67,1.14.16.35.32.7.46,1.05.85,1.92,1.71,3.84,2.56,5.75,1.39-.53,2.97.61,3.46,2.01.5,1.4.22,2.94-.07,4.41l.32-.34c2.22.23,4.33,1.34,5.8,3.01Z",
    style: {
      fill: "#d6faff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.06,73.1l-3.11.61s-.5,2.53-2.67,5.59c-2.16,3.07-3.15-.84-5.49-.37-2.33.47-2.86.04-6.35.67-3.49.63-3.93-2.6-3.93-2.6,1.37-.36,2.84-.16,4.2-.54,2.02-.56,3.58-2.33,5.66-2.64.95-.13,1.93.05,2.85-.17,1.44-.34,2.47-1.56,3.66-2.44,1.19-.88,3.01-1.38,4.04-.32.31.32.49.73.67,1.14.16.35.32.7.46,1.05Z",
    style: {
      fill: "#add8db"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakFreeze);
export default __webpack_public_path__ + "static/media/streak-freeze.69b34c60b5a74a8477323e0228f2b3fb.svg";
export { ForwardRef as ReactComponent };